/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `Compliance` - COMPLIANCE
 * * `Finance` - FINANCE
 * * `Logistics` - LOGISTICS
 * * `Product` - PRODUCT
 * * `Quality` - QUALITY
 */
export type CreateSupportTicketTeamEnum = typeof CreateSupportTicketTeamEnum[keyof typeof CreateSupportTicketTeamEnum];


export const CreateSupportTicketTeamEnum = {
  Compliance: 'Compliance',
  Finance: 'Finance',
  Logistics: 'Logistics',
  Product: 'Product',
  Quality: 'Quality',
} as const;
